import axios from "axios";
import Dexie from 'dexie';
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const Device = {
  async requestPersistentStorage() {
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().then((persistent) => {
        if (persistent) {
        } else {
        
        }
      });
    }
  },

  async getDeviceId() {
    let id;
    try {
      await this.requestPersistentStorage();

      // Request access to the OPFS
      const fsHandle = await navigator.storage.getDirectory();

      // Open the file named 'deviceID.txt'
      const fileHandle = await fsHandle.getFileHandle("deviceID.txt");

      // Get a file object from the file handle
      const file = await fileHandle.getFile();

      // Read the file content as text
      id = await file.text();

      return id;
    } catch (error) {
      id = localStorage.getItem("deviceRegistrationID");
    }

    const db = new Dexie('DeviceDB');
    db.version(1).stores({
      settings: 'key,value' // Simple key-value store
    });

    try {
      const entry = await db.settings.get('deviceID');
      if (entry) {
        id = entry.value;
      }
    } catch (error) {
      console.error('Error accessing IndexedDB:', error);
    }

    if (!id) {
      const cookieValue = document.cookie.split('; ').find(row => row.startsWith('deviceID='));
      id = cookieValue ? cookieValue.split('=')[1] : null;
    }

    if (id && id !== "undefined") {
      return id;
    }

    try {
      id = await this.getFingerPrintID();
    } catch (e) {
      id = generateUUID();
    }


    try {
      const fsHandle = await navigator.storage.getDirectory();

      const fileHandle = await fsHandle.getFileHandle("deviceID.txt", {
        create: true,
      });

      const writable = await fileHandle.createWritable();
      await writable.write(id);
      await writable.close();
    } catch (error) {
    }
    // Save to IndexedDB
    try {
      await db.settings.put({ key: 'deviceID', value: id });
    } catch (error) {
    }
    document.cookie = `deviceID=${id}; path=/; SameSite=Strict; max-age=${2 * 365 * 24 * 60 * 60}`;

    return id;
  },

  getFingerPrintID() {
    const fpPromise = FingerprintJS.load();
    return fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        return result.visitorId;
      });
  },

  getPCName(android) {
    if (android) return this.getDeviceId();
    return axios
        .get(hardwareApi + `utils/getPcName`)
        .then(({ data }) => data)
        .catch((err) =>
            errorHandler.tomcatError(err, false, "Hardware Service Error, Please restart your computer, but if problem persist,")
        );
  },
};